import { useEffect, useRef } from "react"
import { getCable } from "../../../shared/api/cable"

export const useChatNotificationsSocket = ({ enabled, onNewMessage, onPresence }) => {
  const handlersRef = useRef({ onNewMessage, onPresence })
  handlersRef.current = { onNewMessage, onPresence }

  useEffect(() => {
    if (!enabled) return

    const cable = getCable()
    const subscription = cable.subscriptions.create(
      { channel: "ChatNotificationsChannel" },
      {
        received(data) {
          const { onNewMessage, onPresence } = handlersRef.current
          if (data.type === "new_message") onNewMessage?.(data)
          if (data.type === "presence") onPresence?.(data)
        },
      }
    )

    return () => subscription.unsubscribe()
  }, [enabled])
}

export default useChatNotificationsSocket
